import React, { useState } from "react";
import {
  QuestionMarkCircleIcon,
  DocumentTextIcon,
  PlayIcon,
  EnvelopeIcon,
  ClockIcon,
} from "@heroicons/react/24/outline";
import Swal from "sweetalert2";
import { Grid2x2 } from "lucide-react";
import FAQModal from "../../../components/modal/FAQModal";

const Support = () => {
  const [showFAQModal, setShowFAQModal] = useState(false);


  const handleEmailSupport = () => {
    const email = 'admin@cadenceio.com';
    const subject = 'Support Request - CadenceIO';
    const body = 'Please describe your issue or question below:\n\n';
    const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    
    try {
      window.location.href = mailtoLink;
    } catch (error) {
      // Fallback for environments where mailto might not work
      navigator.clipboard.writeText(email).then(() => {
        Swal.fire({
          title: "Email Copied",
          text: `Email address ${email} has been copied to your clipboard.`,
          icon: "success",
          confirmButtonText: "OK",
        });
      }).catch(() => {
        Swal.fire({
          title: "Contact Support",
          text: `Please email us at: ${email}`,
          icon: "info",
          confirmButtonText: "OK",
        });
      });
    }
  };

  return (

    <>
    <div className="max-w-3xl p-4 bg-white rounded-lg shadow-sm sm:p-6">
      <h2 className="mb-4 text-base font-semibold text-gray-800 sm:text-lg">
        Support & Help
      </h2>
      <hr className="mb-4 border-gray-200 sm:mb-6" />

      {/* Help Resources */}
      <div className="mb-4 sm:mb-6">
        <h3 className="mb-4 text-sm font-semibold text-gray-800 sm:text-base">
          Help Resources
        </h3>
        <div className="space-y-4">
          {/* Frequently Asked Questions */}
          <button
           onClick={() => setShowFAQModal(true)}
            className="flex items-center justify-between w-full p-3 transition-colors duration-200 border border-gray-200 rounded-md sm:p-4 hover:bg-gray-50"
            aria-label="Open Frequently Asked Questions"
          >
            <div className="flex items-center">
              <QuestionMarkCircleIcon className="w-4 h-4 mr-2 text-gray-600 sm:w-5 sm:h-5" />
              <span className="text-xs text-gray-800 sm:text-sm">
                Frequently Asked Questions
              </span>
            </div>
            <div className="flex items-center justify-center w-4 h-4 sm:w-5 sm:h-5">
              <Grid2x2 />
            </div>
          </button>

          {/* Product Documentation */}
          <a
            href={process.env.REACT_APP_PRODUCT_DOCS_URL}
            target="_blank"
            className="flex items-center justify-between w-full p-3 transition-colors duration-200 border border-gray-200 rounded-md sm:p-4 hover:bg-gray-50 cursor-pointer"
            aria-label="Open Product Documentation"
          >
            <div className="flex items-center">
              <DocumentTextIcon className="w-4 h-4 mr-2 text-gray-600 sm:w-5 sm:h-5" />
              <span className="text-xs text-gray-800 sm:text-sm">
                Product Documentation
              </span>
            </div>
            <div className="flex items-center justify-center w-4 h-4 sm:w-5 sm:h-5">
              <Grid2x2 />
            </div>
          </a>

          {/* Watch Demo Video */}
          <a
            href={process.env.REACT_APP_DEMO_VIDEO_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-between w-full p-3 transition-colors duration-200 border border-gray-200 rounded-md sm:p-4 hover:bg-gray-50"
            aria-label="Watch Demo Video"
          >
            <div className="flex items-center">
              <PlayIcon className="w-4 h-4 mr-2 text-gray-600 sm:w-5 sm:h-5" />
              <span className="text-xs text-gray-800 sm:text-sm">
                Watch Demo Video
              </span>
            </div>
            <div className="flex items-center justify-center w-4 h-4 sm:w-5 sm:h-5">
              <Grid2x2 />
            </div>
          </a>
        </div>
      </div>

      {/* Contact Support */}
      <div className="mb-4 sm:mb-6">
        <h3 className="mb-4 text-sm font-semibold text-gray-800 sm:text-base">
          Contact Support
        </h3>
        <div className="space-y-4">
          {/* Email Support Team */}
          <div className="flex flex-row items-start justify-between p-3 border border-gray-200 rounded-md max-sm:flex-col sm:p-4">
            <div className="mb-2 sm:mb-0">
              <p className="text-xs font-medium text-gray-800 sm:text-sm">
                Email Support Team
              </p>
              <p className="text-xs text-gray-600">admin@cadenceio.com</p>
            </div>
            <button
              onClick={handleEmailSupport}
              className="bg-blue-600 text-white px-3 sm:px-3 py-1.5 rounded-md hover:bg-blue-700 transition-colors duration-200 w-auto"
            >
              <EnvelopeIcon className="w-4 h-4 sm:w-5 sm:h-5" />
            </button>
          </div>

          {/* Schedule a Call */}
          <div className="flex flex-row items-start justify-between p-3 border border-gray-200 rounded-md max-sm:flex-col sm:p-4">
            <div className="mb-2 sm:mb-0">
              <p className="text-xs font-medium text-gray-800 sm:text-sm">
                Schedule a Call
              </p>
              <p className="text-xs text-gray-600">
                Book a 15-minute slot with our team
              </p>
            </div>
            <a
              href={process.env.REACT_APP_SCHEDULE_CALL_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-blue-600 text-white px-3 sm:px-3 py-1.5 rounded-md hover:bg-blue-700 transition-colors duration-200 w-auto inline-flex items-center justify-center"
            >
              <ClockIcon className="w-4 h-4 sm:w-5 sm:h-5" />
            </a>
          </div>
        </div>
      </div>
    </div>
    {/* FAQ Modal */}
      <FAQModal
        isOpen={showFAQModal}
        onClose={() => setShowFAQModal(false)}
      />

      </>
  );
};

export default Support;
